import { render, staticRenderFns } from "./DeliveryRouteHistoryView.vue?vue&type=template&id=4759655a&"
import script from "./DeliveryRouteHistoryView.vue?vue&type=script&lang=ts&"
export * from "./DeliveryRouteHistoryView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DeliveryRouteHistoryView.vue"
export default component.exports